module.exports = __webpack_public_path__ + "img/Menu-04.17fd7fdf.png";